import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import classNames from "classnames";
import { DATETIME } from "../../utils/dateFormats";

const ChatroomUser = props => {
  const { chatroomUser } = props;

  return (
    <li
      className={"list-group-item"}
    >
      <div>{chatroomUser.first_name} {chatroomUser.last_name}</div>
      <div className="user-last-seen">Seen: {
        chatroomUser.last_accessed ? (
          moment(chatroomUser.last_accessed).format(DATETIME)
        ) : (
          "Never"
        )
      }</div>
    </li>
  )
}

class ChatroomUsers extends React.Component {
  render() {
    const { selectedChatroomUsers } = this.props;

    return (
      <ul className="shadowDepth1 list-group chatroom-users">
        {selectedChatroomUsers.filter(
            (chatroomUser) => !chatroomUser.archived && chatroomUser.digichat_access && chatroomUser.active
          ).map((chatroomUser) =>
          <ChatroomUser
            chatroomUser={chatroomUser}
            key={chatroomUser.user_id}
          />
        )}
      </ul>
    )
  }
}

ChatroomUsers.propTypes = {
  selectedChatroomUsers: PropTypes.array
};

export default ChatroomUsers;
